if (!customElements.get("sample-products")) {
  customElements.define(
    "sample-products",
    class SampleProducts extends HTMLElement {
      constructor() {
        super();

        this.onCheckboxChange = this.onCheckboxChange.bind(this);

        this.maxSample = parseInt(this.dataset.maxSample, 10) || 0;
        this.isMandatory = String(this.dataset.mandatory) === "true";

        this.sampleCheckboxes = document.querySelectorAll('[name="sample"]');
        this.submitBtn = document.querySelector('button#checkout[type="submit"]');
        this.sampleError = document.querySelector(".cart__sample-error");

        if (this.sampleCheckboxes) {
          this.sampleCheckboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", this.onCheckboxChange);
          });
        }

        this.updateCheckoutState();
      }

      onCheckboxChange(event) {
        const isChecked = event.target.checked;
        const productId = event.target.id;
        if (isChecked) {
          this.addSampleProductToCart(productId);
        } else {
          this.removeSampleProductToCart(productId);
        }
        // Note: add/remove triggers a location.reload() on success, so updateCheckoutState
        // will run again after reload. Keep here in case of async variations.
        this.updateCheckoutState();
      }

      updateCheckoutState() {
        if (!this.isMandatory) return;

        // count currently checked sample checkboxes
        const checkedCount = Array.from(document.querySelectorAll('[name="sample"]')).filter((c) => c.checked).length;

        // if maxSample is defined (>0) we require exactly that many selections, otherwise require at least 1
        const required = this.maxSample > 0 ? this.maxSample : 1;

        if (checkedCount < required) {
          // disable checkout button and show message
          if (this.submitBtn) this.submitBtn.disabled = true;
          if (this.sampleError) {
            const message = this.sampleError.dataset.mandatorySampleError;
            this.sampleError.innerHTML = message;
          }
        } else {
          if (this.submitBtn) this.submitBtn.disabled = false;
          if (this.sampleError) this.sampleError.innerHTML = "";
        }
      }

      async addSampleProductToCart(productId) {
        try {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: [
                {
                  quantity: 1,
                  id: productId,
                },
              ],
            }),
          });
          location.reload();
        } catch (error) {
          console.error("Error:", error);
        }
      }

      async removeSampleProductToCart(productId) {
        try {
          await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              updates: { [productId]: 0 },
            }),
          });
          location.reload();
        } catch (error) {
          console.error("Error:", error);
        }
      }
    }
  );
}
